






































































import { Vue, Component } from 'vue-property-decorator';
import EditorType from '@/EditorType';
import { mapGetters, mapMutations } from 'vuex';
import { Getter, Mutation } from 'vuex-class';
import NavbarContextualMenu from '@/components/navbar/NavbarContextualMenu.vue';
import { EditorSave, saveEditor } from '@/file/EditorAsJson';
import { EditorModel } from '@/store/editors/types';

@Component({
  components: { NavbarContextualMenu },
  computed: mapGetters([
    'modelEditors',
    'dataEditors',
    'inCodeVault',
  ]),
  methods: mapMutations(['enterCodeVault']),
})
export default class Navbar extends Vue {
  private editorType = EditorType;
  private isModelContextualMenuOpen = false;
  private isDataContextualMenuOpen = false;
  @Getter('currEditorType') currEditorType!: EditorType;
  @Getter('currEditorModel') currEditorModel!: EditorModel;
  @Getter('overviewEditor') overviewEditor!: EditorModel;
  @Getter('inCodeVault') inCodeVault!: boolean;
  @Mutation('switchEditor') switch!: (arg0: { editorType: EditorType; index: number }) => void;
  @Mutation('updateNodeInOverview') readonly updateNodeInOverview!: (cEditor: EditorModel) => void;

  private switchOverviewEditor() {
    // Save currEditorModel before switching as periodic save may not have captured last changes
    // and update overview editor if required
    this.updateNodeInOverview(this.currEditorModel);

    const oldEditorSaved: EditorSave = saveEditor(this.currEditorModel);
    const overviewEditorSave: EditorSave = saveEditor(this.overviewEditor);
    localStorage.setItem(`unsaved-editor-${this.currEditorModel.name}`, JSON.stringify(oldEditorSaved));
    localStorage.setItem('unsaved-editor-Overview', JSON.stringify(overviewEditorSave));

    this.switch({ editorType: EditorType.OVERVIEW, index: 0 });
  }

  private isSelected(editorType: EditorType) {
    return !this.inCodeVault && (this.currEditorType === editorType) ? 'selected' : '';
  }

  private displayNavbarContextualMenu(editorType: EditorType) {
    switch (editorType) {
      case EditorType.MODEL:
        this.isModelContextualMenuOpen = true;
        break;
      case EditorType.DATA:
        this.isDataContextualMenuOpen = true;
        break;
      default:
        break;
    }
  }

  private hideNavbarContextualMenu(): void {
    this.isModelContextualMenuOpen = false;
    this.isDataContextualMenuOpen = false;
  }
}

